import axios from 'axios';

const api = axios.create({
  baseURL: 'http://196.188.116.41:8000',
});

export default api;
